const JOURNEY_TOKEN_KEY = 'set_session_token'
const JOURNEY_STORAGE_KEYS = [
    JOURNEY_TOKEN_KEY,
    'psychology_field_id',
    'match_additional_data',
]

export function isValidJourneyToken(token) {
    return typeof token === 'string' && token !== '' && token !== 'null' && token !== 'undefined'
}

export function readStoredJourneyToken() {
    try {
        const token = localStorage.getItem(JOURNEY_TOKEN_KEY)
        return isValidJourneyToken(token) ? token : null
    } catch (e) {
        return null
    }
}

export function persistStoredJourneyToken(token) {
    if (!isValidJourneyToken(token)) {
        return null
    }
    localStorage.setItem(JOURNEY_TOKEN_KEY, token)
    return token
}

export function resolveJourneyToken(preferred) {
    return isValidJourneyToken(preferred) ? preferred : readStoredJourneyToken()
}

export function clearJourneyStorage() {
    JOURNEY_STORAGE_KEYS.forEach((key) => {
        localStorage.removeItem(key)
    })
}
